import { TherapistAction } from '../../../src/redux/actions/constant';

export const therapistAssignTaskAction = (payload: any) => {
    return {
        type: TherapistAction.THERAPIST_TASK_ASSIGN_REQUEST,
        payload,
    };
};

export const therapistAssignTaskResetAction = () => {
    return {
        type: TherapistAction.THERAPIST_TASK_ASSIGN_RESET,
    };
};



